// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__htKPw","upload":"Small_upload__3hEFJ","imageWrap":"Small_imageWrap__WcC8E","removeBtn":"Small_removeBtn__1_MCF"};